module.exports = __webpack_public_path__ + "media/6fec0390-7ddc-4d2d-adda-330887e00312.4de7934d.mp4";